import React from "react";
import Select from "react-select";

const CommonSelect = ({
  options = [],
  value,
  onChange,
  isMulti = false,
  placeholder = "Select...",
  isDisabled = false,
  isClearable = true,
  required = false,
  errorMessage = "* This field is required",
  name,
}) => {
  const [error, setError] = React.useState("");

  const handleChange = (selectedOption) => {
    setError(""); // Reset error on change
    onChange(selectedOption);
  };

  const handleBlur = () => {
    if (required && (!value || (isMulti && value.length === 0))) {
      setError(errorMessage);
    }
  };

  const customStyles = {
    control: (styles) => ({
      ...styles,
      minWidth: "500px", // Adjust width as needed
      maxWidth: "500px",
    }),
    menu: (styles) => ({
      ...styles,
      width: "500px", // Set dropdown width
      maxHeight: "400px", // Prevent excessive height
      overflowY: "auto", // Enable scrolling if needed
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "#FF9F43" : isFocused ? "#f038a3" : "white",
      color: isSelected ? "white" : "black",
      padding: "10px",
      whiteSpace: "nowrap", // Prevent line breaks
      overflow: "hidden",
      textOverflow: "ellipsis", // Show "..." for long text
    }),
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#FF9F43",
      color: "white",
      maxWidth: "500px", // Restrict width for selected items
      display: "flex",
      alignItems: "center",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: "white",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: "white",
      ":hover": {
        backgroundColor: "darkred",
        color: "white",
      },
    }),
  };
  
  

  return (
    <div className="common-select-wrapper">
      <Select
        options={options}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        isMulti={isMulti}
        isDisabled={isDisabled}
        isClearable={isClearable}
        placeholder={placeholder}
        classNamePrefix="common-select"
        name={name}
        styles={customStyles}
      />
      {error && <div className="text-danger">{error}</div>}
    </div>
  );
};

export default CommonSelect;
